<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">自定义报表</span></div>
		<div class="margin-top margin-left">
			<Button color="primary" @click="createModel=true">新建报表</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="name" title="报表名称"/>
				<TableItem prop="templateKey" title="标识"/>
				<TableItem>
					<div class="actions" slot-scope="{data}">
						<router-link :to="{name:'ReportView',params:{reportId:data.id}}" tag="span">查看</router-link>
						<router-link tag="span" :to="{name:'TemplateForm',params:{templateId:data.id}}">编辑</router-link>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="createModel" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">新建自定义报表</div>
			<Form :labelWidth="80" ref="createForm" :rules="validationRules" :model="form">
				<FormItem label="报表名称" prop="name">
					<input v-model="form.name" type="text" placeholder="请输入报表名称">
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="createModel=false" :loading="loading">取消</Button>
				<Button color="primary" :loading="loading" @click="create()">创建并设计</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	export default {
		name: "CustomReport",
		data() {
			return {
				loading: false,
				createModel: false,
				form: {
					name: ''
				},
				validationRules: {
					required: ['name']
				},
				dataList: []
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.report.template.list({type: 100}).then(({data}) => {
					this.dataList = data || [];
				}).finally(() => {
					this.loading = false;
				});
			},
			//新建空白模板（type=100），成功后跳转到报表项目设计页
			create() {
				let validResult = this.$refs.createForm.valid();
				if (validResult.result) {
					this.loading = true;
					this.$api.report.template.save({
						name: this.form.name,
						templateKey: 'custom' + Date.now(),
						type: 100
					}).then(({data}) => {
						this.createModel = false;
						this.form.name = '';
						this.$router.push({name: 'TemplateForm', params: {templateId: data.id}});
					}).catch(() => {
					}).finally(() => {
						this.loading = false;
					});
				}
			},
			remove(data) {
				//已配置数据项的报表做删除拦截提示
				this.$api.report.template.load(data.id).then(({data: template}) => {
					let hasItems = template && template.items && template.items.length > 0;
					let tip = hasItems ? '该报表已配置数据项，删除后不可恢复，确认删除?' : '确认删除?';
					this.$Confirm(tip).then(() => {
						this.$api.report.template.delete(data.id).then(() => {
							this.loadList();
						})
					})
				})
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>

<style scoped>

</style>
